import { render } from "./JobsList.vue?vue&type=template&id=0bb08eb6"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"
script.render = render

export default script